import { UseCase } from "../../useCase"
import { ExportSurveyOptionsRequest } from "./request"
import { ExportSurveyOptionsResponse } from "./response"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class ExportSurveyOptionsUseCase implements UseCase<ExportSurveyOptionsRequest, ExportSurveyOptionsResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(request: ExportSurveyOptionsRequest): Promise<ExportSurveyOptionsResponse> {
		return this._repository.exportSurveyOptions(request.surveyId)
	}
}
